import { formattedDateString, timeFormat } from 'commons/utils/commonUtil';
import TimeCode from 'commons/utils/TimeCode';
import KeyFlowVO from 'commons/vo/KeyFlowVO';
import ThumbnailDefault from 'asset/thumbnail/thumb_default.jpg';
import HostFactory from 'commons/handler/HostFactory';
import { LibraryStatusText } from 'commons/constants/KeyFlowConstants';

class Library extends KeyFlowVO {
  private DEFAULT_MEDIA_FPS = 29.97;

  id: number;
  contents: string;
  categoryId: number;
  videoId: number;
  resolution: Resolution;
  inPoint: number;
  outPoint: number;
  isAvailableDownload: number;
  downloadCount: number;
  requester: string;
  // requesterId: number;
  isDeleted: number;
  // dateOfExpired: string;
  dateOfCreated: string;
  dateOfModified: string;
  assetTitle: string;
  mediaFps: number;
  status: MediaconvertStatus | KeyFlowLibraryStatus | string;

  // symbolicPath: string;
  _filePath: string;
  thumbnailPath: string;
  elapsedTime: number;

  timecodeUtil: TimeCode;

  constructor(data: LibraryProps) {
    super(data);
    this.id = data.ID;
    this.contents = data.CONTENTS;
    this.categoryId = data.CATEGORY_ID;
    this.videoId = data.VIDEO_ID;
    this.resolution = data.RESOLUTION;
    this.inPoint = data.IN_POINT;
    this.outPoint = data.OUT_POINT;
    this.isAvailableDownload = data.IS_AVAILABLE_DOWNLOAD;
    this.downloadCount = data.DOWNLOAD_COUNT;
    this.requester = data.REQUESTER;
    // this.requesterId = data.REQUESTER_ID;
    this.isDeleted = data.IS_DELETED;
    // this.dateOfExpired = data.DATE_OF_EXPIRED;
    this.dateOfCreated = data.DATE_OF_CREATED;
    this.dateOfModified = data.DATE_OF_MODIFIED;
    this.assetTitle = data.ASSET_TITLE;
    this.mediaFps = data.MEDIA_FPS;
    this.status = data.STATUS;

    // this.symbolicPath = data.SYMBOLIC_PATH;
    this._filePath = data.FILE_PATH;
    this.thumbnailPath = data.THUMBNAIL_PATH;
    this.elapsedTime = data.ELAPSED_TIME;

    this.timecodeUtil = new TimeCode(this.mediaFps || 29.97);
  }

  get formattedDateOfCreated() {
    return formattedDateString(this.dateOfCreated);
  }

  get inTimecode() {
    const util = this.timecodeUtil;
    util.setFrames(this.inPoint);
    return util.getTimeCode();
  }

  get outTimecode() {
    const util = this.timecodeUtil;
    util.setFrames(this.outPoint);
    return util.getTimeCode();
  }

  get durationTimecode() {
    const util = this.timecodeUtil;
    util.setFrames(this.outPoint - this.inPoint);
    return util.getTimeCode();
  }

  get workingTime() {
    return timeFormat(this.elapsedTime || 0, 'hh:mm:ss', false);
  }

  get filePath() {
    const isStartWith = this.startWithSlash(this._filePath);
    const path = this._filePath;

    return isStartWith ? path.substring(1) : path;
  }

  startWithSlash(value?: string) {
    let result = false;

    if (value) {
      result = value.trim().startsWith('/');
    }

    return result;
  }

  getThumbnailBackgroundURL() {
    const hasSlash = this.startWithSlash(this.thumbnailPath);
    const thumbnailPath = hasSlash ? `${this.thumbnailPath}` : `/${this.thumbnailPath}`;
    return `url(${HostFactory.cloudfrontURL}${thumbnailPath}), url(${ThumbnailDefault})`;
  }

  getLibraryStatusText() {
    return LibraryStatusText[this.status] || '-';
  }
}

export default Library;
